<!-- section template -->
<template>
  <div>
    <div v-show="step === 1">
      <ValidationObserver v-slot="{ invalid, handleSubmit }">
        <el-form
          ref="form"
          :model="FormMixSubmitData"
          label-position="top"
          class="isStyleBase"
          :class="[$style.formLogin, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]"
          @submit.prevent.native="handleSubmit(onSubmitGetcode)"
        >
          <div v-if="type === 'dialog'" class="formLogin__title"> 登入或註冊 </div>
          <div v-if="type === 'dialog'" class="formLogin__description"> 為確保你的資訊安全，請進行手機驗證 </div>
          <ValidationProvider v-slot="{ errors }" :rules="FormMixSubmitData.phoneCode === '+886' ? 'require|phone' : 'require'" name="手機號碼">
            <el-form-item :error="errors[0]" prop="phoneNumber">
              <el-input ref="phoneNumber" v-model="FormMixSubmitData.phoneNumber" placeholder="手機號碼" autocomplete="tel" inputmode="tel">
                <CountryCodePicker slot="prepend" v-model="FormMixSubmitData.phoneCode" />
              </el-input>
            </el-form-item>
          </ValidationProvider>
          <BaseButton :disabled="invalid" :loading="$isLoading('getCode')" class="isStylePrimary isFull mt-2 mb-3" :class="{ isRadius: $globalIsJtails }" type="submit"> 發送驗證碼 </BaseButton>
          <div class="text-center">
            驗證後即代表同意
            <BaseButton class="isStylePrimary isTextUnderline" @click="openDialogPrivacy"> 隱私權條款 </BaseButton>
          </div>
        </el-form>
        <BasePre>FormMixSubmitData: {{ FormMixSubmitData }}</BasePre>
      </ValidationObserver>
    </div>
    <div v-show="step === 2">
      <ValidationObserver ref="verifycodeObserver" v-slot="{ invalid, handleSubmit }">
        <el-form
          ref="form"
          v-loading="$isLoading('logIn') || $isLoading('wordpressLogIn')"
          element-loading-text="正在驗證..."
          :model="FormMixSubmitData"
          label-position="top"
          class="isStyleBase"
          :class="[$style.formVerifycode, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]"
          @submit.prevent.native=""
        >
          <div class="formVerifycode__title"> 驗證 </div>
          <div class="formVerifycode__description"> 請輸入傳送至 {{ FormMixSubmitData.phoneCode }} {{ FormMixSubmitData.phoneNumber }} <br />的{{ $globalIsOfficial ? 6 : 4 }}位數驗證碼 </div>
          <ValidationProvider v-slot="{ errors }" :rules="$globalIsOfficial ? 'require|digits:6' : 'require|digits:4'" name="手機驗證碼">
            <el-form-item prop="verificationCode">
              <div class="flex">
                <div class="flex-grow">
                  <el-input
                    ref="verificationCode"
                    v-model="FormMixSubmitData.verificationCode"
                    :maxlength="$globalIsOfficial ? 6 : 4"
                    :placeholder="$globalIsOfficial ? '______' : '____'"
                    autocomplete="one-time-code"
                    inputmode="numeric"
                    class="isStyleVerify"
                    @input="onInputVerificationCode"
                  ></el-input>
                </div>
              </div>
            </el-form-item>
          </ValidationProvider>

          <BaseButton
            v-if="$globalIsDingBeauty"
            class="isStylePrimary isFull mb-3 mt-4"
            :class="{ isOutline: coldDownGetcode === 0, isRadius: $globalIsJtails }"
            :disabled="!verificateCodeInputStatus"
            @click="onSubmitVerifycode"
          >
            驗證<span v-if="coldDownGetcode > 0"></span>
          </BaseButton>
          <BaseButton class="isStylePrimary isFull mb-4" :class="{ isOutline: coldDownGetcode === 0, isRadius: $globalIsJtails }" :disabled="coldDownGetcode > 0" @click="onResend">
            重新傳送<span v-if="coldDownGetcode > 0">({{ coldDownGetcode }}s)</span>
          </BaseButton>
          <BaseButton v-if="type === 'dialog'" class="isStyleDark isTextUnderline isFull" :class="{ isRadius: $globalIsJtails }" @click="onCancel"> 取消驗證 </BaseButton>
          <BaseButton v-if="type === 'page'" class="isStyleDark isTextUnderline isFull" :class="{ isRadius: $globalIsJtails }" @click="step = 1"> 返回 </BaseButton>
          <BaseButton class="isStyleDark isTextUnderline isFull mt-5" :class="{ isRadius: $globalIsJtails }" @click="openDialogNewsletterTip"> 收不到簡訊驗證碼？ </BaseButton>
        </el-form>
        <BasePre>FormMixSubmitData: {{ FormMixSubmitData }}</BasePre>
      </ValidationObserver>
    </div>
    <GoogleReCaptchaV3 id="get_code_captcha" ref="captcha" v-model="FormMixSubmitData.g_recaptcha_response" :site-key="googleReCaptcha.siteKey" :inline="false" action="get_code"></GoogleReCaptchaV3>
  </div>
</template>

<script>
import formMixin from './mixins/form'
import { messageSuccess, messageError } from '@utils/message'
import formatErrorMessage from '@utils/format-response-message'
import { authComputed, merchantComputed } from '@store/helpers'
import configSSO from '@src/config/sso'

const DEFAULT_COLD_DOWN_GET_CODE = 60
const DEFAULT_SUBMIT_DATA = {
  phoneCode: '+886',
  phoneNumber: '',
  verificationCode: '',
}

export default {
  name: 'FormLogin1',
  components: {
    CountryCodePicker: () => import('@components/Country/CountryCodePicker'),
    GoogleReCaptchaV3: () => import('@components/GoogleReCaptchaV3'),
  },
  mixins: [formMixin],
  props: {
    value: {
      type: Object,
      default: () => {
        return { ...DEFAULT_SUBMIT_DATA }
      },
    },
    fromStep: {
      type: Number,
      default: 1,
    },
    type: {
      type: String,
      default: 'dialog',
      validator(value) {
        return ['dialog', 'page'].includes(value)
      },
    },
    afterLoginRouteName: {
      type: String,
      default: 'member',
    },
  },
  data() {
    return {
      coldDownGetcode: 0,
      step: 1,
      test: true,
      code: new Array(window.globalData.APP_ENV === 'production' ? 6 : 4).fill(null),
      verificateCodeInputStatus: false,
      googleReCaptcha: {
        siteKey: '6Lf2LlcbAAAAANb1gKClQNEbRRAjU5RfIJ3sIm3v',
      },
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
  },
  watch: {
    step(value) {
      this.$emit('update:fromStep', value)
    },
    fromStep(value) {
      this.step = value
    },
    code(nvl) {
      const nullIndex = nvl.findIndex((item) => item === null || item === '')
      if (this.$refs[`verificateFourInput${nullIndex}`]) {
        this.$refs[`verificateFourInput${nullIndex}`][0].focus()
        this.FormMixSubmitData.verificationCode = ''
      }
      if (nvl.every((item) => item !== null && item !== '')) {
        this.FormMixSubmitData.verificationCode = `${nvl.join('')}`
      }
      this.verificateCodeInputStatus = this.FormMixSubmitData.verificationCode.length === this.code.length
    },
  },
  mounted() {
    const initDevelopmentAutocomplete = () => {
      if (this.$globalIsDevelopment) {
        this.FormMixSubmitData.phoneNumber = '0911222333' // 0932339431
        this.FormMixSubmitData.verificationCode = ''
      }
    }

    initDevelopmentAutocomplete()
    this.$refs.phoneNumber.focus()
  },
  methods: {
    onSubmitGetcode() {
      this.tryToGetcode()
    },
    onSubmitVerifycode() {
      this.tryToLogin()
    },
    onCancel() {
      this.$emit('cancel')
    },
    onResend() {
      messageSuccess('已發送')
      this.tryToGetcode()
    },
    tryToGetcode() {
      const isProduction = window.globalData.APP_ENV === 'production'
      const { phoneCode, phoneNumber, g_recaptcha_response } = this.FormMixSubmitData

      if (!g_recaptcha_response && isProduction) {
        messageError('驗證失敗')
        return
      }

      const getCodeCallBackFn = (cooldown) => {
        this.runcoldDownGetcodeClock(cooldown)
        this.step = 2
        this.$nextTick(() => {
          this.$refs.verifycodeObserver.reset()
          if (this.$refs.verificationCode) {
            this.$refs.verificationCode.focus()
          }
        })
      }

      this.$store
        .dispatch('auth/getCode', {
          phoneCode,
          phoneNumber,
          g_recaptcha_response: isProduction ? g_recaptcha_response : '',
          forceSms: this.$globalIsLiffClient,
        })
        .then(() => {
          getCodeCallBackFn()
        })
        .catch((e) => {
          if (e.status === 'MERCHANT_MEMBER_FRONT_SEND_VERIFICATION_CODE_IN_COOL_DOWN') {
            getCodeCallBackFn(e.data?.diffSecond || 60)
            messageError({ message: '驗證碼發送失敗，請稍後再試', duration: 3000 })
          } else {
            messageError(formatErrorMessage(e.status))
          }
        })
    },
    async tryToLogin() {
      const { phoneCode, phoneNumber, verificationCode } = this.FormMixSubmitData
      await this.$store
        .dispatch('auth/logIn', {
          phoneCode,
          phoneNumber,
          verificationCode,
        })
        .then((response) => {
          if (this.$route.query.liffUserId) {
            this.tryToLineBind()
          } else {
            setTimeout(() => {
              // this.$FormMixinOnSubmitSuccess()
              this.onLoginSuccess()
            }, 300)
          }
        })
    },
    tryToLineBind() {
      this.$store
        .dispatch('auth/lineBind', {
          lineId: this.$route.query.liffUserId,
        })
        .then(() => {
          this.tryToLineLogIn()
        })
    },
    tryToLineLogIn() {
      this.$store
        .dispatch('auth/lineLogIn', {
          lineId: this.$route.query.liffUserId,
        })
        .then(() => {
          setTimeout(() => {
            // this.$FormMixinOnSubmitSuccess()
            this.onLoginSuccess()
          }, 300)
        })
    },
    async onLoginSuccess() {
      const path = this.$route.query.redirectFrom ? this.$route.query.redirectFrom : `/${this.afterLoginRouteName}`
      const url = new URL(`${window.location.origin}${path.replace(window.location.origin, '')}`)

      if (this.$globalIsJtailsMode && configSSO.enabled) {
        await this.$store.dispatch('auth/wordpressLogIn', url)
      }
      location.reload()
      window.localStorage.setItem('redirectTo', JSON.stringify(this.$route.query))
    },
    runcoldDownGetcodeClock(cooldown) {
      if (this.coldDownGetcode > 0) {
        return false
      }

      this.coldDownGetcode = cooldown || DEFAULT_COLD_DOWN_GET_CODE

      const clock = window.setInterval(() => {
        this.coldDownGetcode = this.coldDownGetcode <= 0 ? (this.coldDownGetcode = DEFAULT_COLD_DOWN_GET_CODE) : this.coldDownGetcode - 1

        if (this.coldDownGetcode <= 0) {
          window.clearInterval(clock)
        }
      }, 1000)
    },
    onInputVerificationCode(e) {
      const verificationCodLength = this.$globalIsOfficial ? 6 : 4

      if (e.length === verificationCodLength) {
        this.onSubmitVerifycode()
      }
    },
    openDialogPrivacy() {
      this.$globalDialog('DialogPrivacy')
    },
    openDialogNewsletterTip() {
      this.$globalDialog('DialogNewsletterTip')
    },
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.formLogin {
  :global {
    .formLogin {
      &__title {
        margin-bottom: 0.75rem;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 1.5;
        text-align: center;
      }

      &__description {
        margin-bottom: 2.5rem;
        font-size: 0.875rem;
        line-height: 1.75;
        color: $color-gray-2;
        text-align: center;
      }
    }
  }

  &.isStyleDingBeauty {
    :global {
      .formLogin {
        &__title {
          font-size: 1.125rem;
          font-weight: 500;
        }
      }
    }
  }
}

.formVerifycode {
  :global {
    .formVerifycode {
      &__title {
        margin-bottom: 0.75rem;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 1.5;
        text-align: center;
      }

      &__description {
        margin-bottom: 2.5rem;
        font-size: 0.875rem;
        line-height: 1.75;
        color: $color-gray-2;
        text-align: center;
      }
    }

    .verificateFourInput {
      display: flex;
      justify-content: center;

      :global {
        .el-input {
          height: 50px;
          width: 50px;
          margin-right: 5px;
          margin-left: 5px;
        }

        .el-input__inner {
          text-align: center;
          padding-left: unset;
          padding-right: unset;
          font-size: 1.25rem;
          letter-spacing: 0;
          height: inherit;
        }
        /* Chrome, Safari, Edge, Opera */
        input[type='number']::-webkit-outer-spin-button,
        input[type='number']::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        /* Firefox */
        input[type='number'] {
          -moz-appearance: textfield;
        }
      }
    }
  }
}
</style>
